import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $('#payment-attention-modal').modal('show');
  }
}
